import { cubicEaseOut } from '@helpers/animate';
import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
import { ButtonType } from './ButtonType';
const Container = styled.button `
  display: inline-flex;
  align-items: center;
  border: 0;
  background: var(--colorPrimary);
  background-image: linear-gradient(to right, var(--colorContrast), var(--colorContrast));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  border-radius: 8px;
  color: var(--colorContrast);
  height: 64px;
  padding: 0px 32px;
  text-decoration: none;
  transition: background-size 0.15s ${cubicEaseOut}, border-color 0.15s ${cubicEaseOut};
  user-select: none;
  width: auto;

  &[data-fill='right'] {
    background-position: left center;
  }

  &[data-fill='left'] {
    background-position: right center;
  }

  span& {
    button:focus &,
    a:focus & {
      outline: auto;
      outline-offset: 3px;
    }

    button:hover &,
    a:hover & {
      color: var(--colorPrimary);
      background-size: 100% 100%;
    }
  }

  &:not(span) {
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &:focus {
      outline: auto;
      outline-offset: 5px;
    }

    &:hover {
      color: ${brand.white};
      background-size: 100% 100%;
    }
  }

  &[data-type=${ButtonType.Default}] {
    --colorPrimary: ${brand.orange};
    --colorContrast: ${brand.black};
  }

  &[data-type=${ButtonType.Outline}] {
    --colorPrimary: ${brand.white};
    --colorContrast: ${brand.black};

    border: 2px solid var(--colorContrast);
  }

  &[data-type=${ButtonType.FullWidth}] {
    --colorPrimary: ${brand.green.honey};
    --colorContrast: ${brand.black};
    width: 100%;
    height: 56px;
  }

  &[data-type=${ButtonType.ThinOutline}] {
    --colorPrimary: ${brand.white};
    --colorContrast: ${brand.black};
    border: 2px solid var(--colorContrast);
    height: 56px;

    @media ${until(Device.TabletLarge)} {
      height: 48px;
    }
  }

  &[data-icon-only='true'] {
    height: 64px;
    justify-content: center;
    padding: 0;
    width: 64px;
  }

  /* Increase specificity to override :not(span) style */
  &:disabled:disabled:disabled {
    background-size: 0% 100%;
    opacity: 0.7;
    pointer-events: none;
  }

  @media ${until(Device.TabletLarge)} {
    height: 48px;
    padding: 0px 16px;

    &[data-icon-only='true'] {
      height: 48px;
      width: 48px;
    }
  }
`;
const Text = styled.span `
  color: currentColor;
  ${fonts.montserrat.bold};
  font-size: 18px;
  line-height: 1em;
  text-decoration: none;
  transition: color 0.15s ${cubicEaseOut};

  [data-icon-only='true'] & {
    ${srOnly};
  }

  @media ${until(Device.TabletLarge)} {
    font-size: 15px;
  }

  [data-type=${ButtonType.FullWidth}] & {
    ${fonts.montserrat.medium}
    font-size: 16px;
    line-height: 1em;
  }
`;
const IconWrapper = styled.div `
  display: block;
  color: currentColor;
  height: 24px;
  margin: 0;
  padding: 0;
  transition: color 0.15s ${cubicEaseOut};
  width: 32px;

  @media ${until(Device.TabletLarge)} {
    height: 20px;
    width: 28px;
  }

  [data-icon-position='left'] & {
    margin-right: auto;
    order: -1;
    padding-right: 8px;
  }

  [data-icon-position='right'] & {
    margin-left: auto;
    order: 1;
    padding-left: 8px;
  }

  [data-icon-only='true'] & {
    color: currentColor;
    height: 24px;
    margin: 0;
    padding: 0;
    width: 24px;

    @media ${until(Device.TabletLarge)} {
      height: 20px;
      width: 20px;
    }
  }
`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
